import React from 'react';
import ApolloClient from 'apollo-boost';
import { ApolloProvider } from '@apollo/react-hooks';
import Layout from '../components/layout';
import SEO from '../components/seo';
import styled from 'styled-components';

import { SettingProvider } from '../lib/context/settings';
import { AdsProvider } from '../lib/context/ads';
import { SectionTitle, Title } from '../components/styles';
import { Col, Row } from 'antd';
import { branchSurveyLinks } from '../data/branch-surveys';

const client = new ApolloClient({
  uri: `https://${process.env.GATSBY_WORDPRESS_URL_PATH}/graphql`,
});

const GoogleImage = styled(Col)`
  text-align: center;
  @media screen and (min-width: 675px) {
    text-align: left;
  }
`;

const DisplayBranchSurveyLinks: React.FC<{
  breakNumber?: number;
  range: string;
}> = ({ breakNumber = 20, range = 'below' }) => {
  if (range === 'below') {
    return (
      <>
        {branchSurveyLinks.map((branch, index) => {
          if (index < breakNumber) {
            return (
              <a
                key={branch.key}
                target="_blank"
                rel="noopener noreferrer"
                href={branch.url}
                className={`${branch.cta}CCSurveyClick`}
                style={{
                  width: '100%',
                  fontWeight: 700,
                  display: 'block',
                  marginBottom: 8,
                }}
              >
                {branch.label}
              </a>
            );
          }
        })}
      </>
    );
  } else {
    return (
      <>
        {branchSurveyLinks.map((branch, index) => {
          if (index >= breakNumber) {
            return (
              <a
                key={branch.key}
                target="_blank"
                rel="noopener noreferrer"
                href={branch.url}
                className={`${branch.cta}CCSurveyClick`}
                style={{
                  width: '100%',
                  fontWeight: 700,
                  display: 'block',
                  marginBottom: 8,
                }}
              >
                {branch.label}
              </a>
            );
          }
        })}
      </>
    );
  }
};

const PageCarCareSurvey: React.FC<any> = () => {
  return (
    <ApolloProvider client={client as any}>
      <SettingProvider>
        <AdsProvider>
          <Layout key={`${typeof window}`}>
            <SEO
              title="Car Care Survey - Thank You | AAA Carolinas"
              description="Thank you for completing our survey. Your feedback helps us continually work to improve our service and recognize those employees who have provided an exemplary experience."
              canonicalUrl="/carcare-survey"
            />

            <Row style={{ paddingTop: 48 }}>
              <Col xs={{ span: 22, offset: 1 }} md={{ span: 20, offset: 2 }}>
                <Title>One More Thing</Title>
              </Col>

              <Col
                xs={{ span: 22, offset: 1 }}
                md={{ span: 20, offset: 2 }}
                style={{ marginTop: 24 }}
              >
                <Row>
                  <Col xs={{ span: 24 }} md={{ span: 12 }}>
                    <p>
                      Thank you for completing our survey. Your feedback helps
                      us continually work to improve our service and recognize
                      those employees who have provided an exemplary experience.
                      Please take a moment to rate the AAA branch you visited.
                    </p>
                  </Col>
                  <GoogleImage xs={{ span: 24 }} md={{ span: 11, offset: 1 }}>
                    <img
                      src="/img/automotive/review-us-on-google.jpg"
                      width="100%"
                      style={{ maxWidth: 140, marginTop: '-16px' }}
                    />
                  </GoogleImage>
                </Row>
              </Col>
              <Col
                xs={{ span: 22, offset: 1 }}
                md={{ span: 12, offset: 2 }}
                style={{ marginTop: 32, marginBottom: 64 }}
              >
                <SectionTitle>Select Your Branch</SectionTitle>
                <Row>
                  <Col xs={{ span: 24 }} md={{ span: 12 }}>
                    <DisplayBranchSurveyLinks breakNumber={20} range="below" />
                  </Col>
                  <Col xs={{ span: 24 }} md={{ span: 12 }}>
                    <DisplayBranchSurveyLinks breakNumber={20} range="above" />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Layout>
        </AdsProvider>
      </SettingProvider>
    </ApolloProvider>
  );
};

export default PageCarCareSurvey;
